<template>
  <div :class="[$style.warningIcon, removeVerticalOffset && $style.warningIcon_noOffset]">
    <svg :width="width" :height="height" :viewBox="`0 0 ${width} ${height}`" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M7.03086 4.59907C7.43017 3.80031 8.56983 3.80031 8.96914 4.59907L15.8842 18.4316C16.2444 19.1522 15.7205 20 14.9151 20H1.08493C0.279452 20 -0.244432 19.1522 0.11579 18.4316L7.03086 4.59907Z"
        :fill="fillBackgroundColor"
      />
      <path
        d="M8.5 10.5C8.5 10.2239 8.27614 10 8 10C7.72386 10 7.5 10.2239 7.5 10.5V14.5C7.5 14.7761 7.72386 15 8 15C8.27614 15 8.5 14.7761 8.5 14.5V10.5Z"
        :fill="fillCenterColor"
      />
      <path
        d="M8 17C8.27614 17 8.5 16.7761 8.5 16.5C8.5 16.2239 8.27614 16 8 16C7.72386 16 7.5 16.2239 7.5 16.5C7.5 16.7761 7.72386 17 8 17Z"
        :fill="fillCenterColor"
      />
    </svg>
  </div>
</template>
  
  <script type="text/ecmascript-6">
  export default {
    name: 'WarningIconTriangle',
    props: {
        width: {
            type: Number,
            default: 16
        },
        height: {
            type: Number,
            default: 24
        },
        fillBackgroundColor: {
            type: String,
            default: '#DC5800'
        },
        fillCenterColor: {
            type: String,
            default: 'white'
        },
        removeVerticalOffset: {
            type: Boolean,
            default: false
        },
    },

    setup(props) {
        return props
    }
}
  </script>

<style lang="scss" module>
.warningIcon {
    margin-top: -2px;
}

.warningIcon_noOffset {
    margin-top: 0;
}
</style>
  